module.exports = __webpack_public_path__ + "static/media/responsive.d216996e.png";